<template>
  <div>
    <div
      class="navBar"
      :class="bouns===true?'header_fixed':''"
      id="navBar"
      @mouseleave="handleCartMouseOut($event)"
      @click="handleSignUpToggle(!signUpModalOpen, $event)"
    >
      <signUpModal v-if="signUpModalOpen"></signUpModal>
      <refreshSession 
        v-if="showSessionModal"
        v-bind:onClose="closeSessionExpirationModal"
      ></refreshSession>
        <!--header-->
        <header class="site-header">
          <!-- top nav bar -->
          <div class="nav_top">
            <div v-if="!isMobile && !business" class="note">
              <img src="../assets/img/icon_truck.png" alt="">
              <span>$5 flat delivery fee with order over $40 </span>
            </div>
            <div v-if="isMobile && !business" class="note">
              <span>Over $40</span>
              <img src="../assets/img/icon_truck.png" alt="">
              <span>$5</span>
            </div>
            <div v-if="!isMobile" class="note">
              <!-- <span :style="'paddingLeft: 20px;'">
                FedEx is having 
                <a 
                  href="https://www.fedex.com/en-us/service-alerts.html"
                  target="_blank"
                  :style="'cursor:pointer; color: white; text-decoration: underline;'"
                >
                  nationwide shipping delays.
                </a>
              </span> -->
            </div>
            <div v-if="business" class="note">
            </div>
            <ul>
              <li>
                <a class="nav_top_icon" v-if='$i18n.locale=="en"' @click="langChanged('ch')">
                  <img src="../assets/img/icon_en.png" alt="">
                  <span class="navusername mobile_hide">English</span>
                </a>
                <a class="nav_top_icon" v-if='$i18n.locale=="ch"' @click="langChanged('en')">
                  <img src="../assets/img/icon_ch.png" alt="">
                  <span class="navusername mobile_hide">中文</span>
                </a>
              </li>
              <li>
                <a href="javascript:$zopim.livechat.window.show();">
                  <img src="../assets/img/chat.png">
                  <span class="mobile_hide">{{ $t('zendesk') }}</span>
                </a>
              </li>
              <li>
                <a class="search" @mouseover="showAccountPortal=false">
                  <router-link to="/search">
                    <img src="../assets/img/icon_search.png" alt="Search">
                    <span class="mobile_hide">{{ $t('search') }}</span>
                  </router-link>
                </a>
              </li>
              <li>
                <div class="nav_top_icon" v-if="!loggedIn" @click="routeSignUp()">
                  <img src="../assets/img/icon_user.png" alt="user">
                  <span class="navusername mobile_hide">{{ $t('signIn') }}</span>
                </div>
                <a href="javascript:void(0);" class="nav_top_icon" v-if="loggedIn" @mouseover="handleMouseIn($event)" @click="navToAccount('orders')">
                  <img src="../assets/img/icon_user.png" alt="user">
                  <span class="navusername mobile_hide">{{ $t('hi') }}, {{this.$store.state.auth.userDetails.FirstName}}</span>
                </a>
              </li>
              <div class="account-portal-modal" v-bind:style="userIconCoordinate" v-if="showAccountPortal && loggedIn && !isMobile" @mouseout="handleMouseOut">
                <div class="arrow"></div>
                <div class="modal-data-container">
                  <h3 class="bubble-node">{{ $t('account') }}</h3>
                  <p class="bubble-node usernameDisplayInBuble" @click="navToAccount('orders')">{{this.$store.state.auth.userDetails.email}}</p>
                  <div class="bubble-node portal-links-container">
                    <div class="bubble-node each-link" @click="navToAccount('orders')">{{ $t('reviewOrder') }}</div>
                    <div class="bubble-node each-link" @click="navToAccount('addresses')">{{ $t('editAddAddress') }}</div>
                    <div class="bubble-node each-link" @click="navToAccount('informations')">{{ $t('accountInformation') }}</div>
                  </div>
                  <div class="bubble-node logout" @click="signOut">{{ $t('logOut') }}</div>
                </div>
              </div>
              <li @mouseover="showAccountPortal=false">
                <a href="javascript:void(0);" class="cart-link" @click="handleCartClick($event)" @mouseenter="handleCartMouseOver($event)">
                  <img v-if="windowWidth > 990" src="../assets/img/icon_cart_white.png" alt="cart">
                  <img v-if="windowWidth <= 990" src="../assets/img/icon_cart_black.png" alt="cart">
                  <span class="cart-title" >{{ $t('cart') }}</span>
                  <div v-if="windowWidth > 990" v-show="cart>0" class="site-header__cart-count"><span>{{cart}}</span></div>
                  <div v-if="windowWidth <= 990" v-show="cart>0" class="site-header__cart-count-mobile"><span>{{cart}}</span></div>
                </a>
              </li>
            </ul>
          </div>
          <!-- end top nav bar -->
          <!-- top nav bar -->
          <div class="nav">
            <div class="nav_phone_left hidden-md-and-up" @click="phoneNavShow">
              <img src="../assets/img/icon_hamgurger.png" alt="">
            </div>
            <div class="logo">
              <router-link to="/">
                <img v-if="this.business === true" src="../assets/img/b2b_logo.png" alt="">
                <img v-else src="../assets/img/b2c_logo.png" alt="">
              </router-link>
            </div>
            <ul class="hidden-sm-and-down">
              <li
                class="nav-icon"
                v-for="(group, index) in filterGroup(allGroups)"
                data-index="index"
                :key="index"
                @click="navGo(group.ProductGroup_id)"
                @mouseover="change(group.Name, index)"
                @mouseleave="change('', allGroups.length)"
              >
                <img :style="'height: 52px'" :src="(hoverIndex === index) ? ((hoverImage[group.ProductGroup_id]) ? hoverImage[group.ProductGroup_id] : group.Image) : group.Image"/>
                <span v-if='$i18n.locale=="en"'>{{group.Name}}</span>
                <!-- group.Description missing all Chinese translations. *NEED FIX* -->
                <!-- https://mmstage-scm.truckxi.com/api/v1/mobile/group/ -->
                <span v-if='$i18n.locale=="ch"'>{{group.Description}}</span>
              </li>
            </ul>
          </div>
          <!-- end nav bar -->
        </header>
        <!-- while signed out -->
        <div
          :style="this.mobileSignUp ?' transform: translateY(-24px);':'transform: translateY(-100%);'"
          class="mobile-nav-wrapper hidden-md-and-up"
          :class="[MobileShow ?'sub_nav__is_open':'', this.mobileSignUp ?'mobile_nav_wrapper_show':'']"
        >
          <div class="mobile-nav" v-for="(item, index) in mobileSignInCategories" data-index="index" :key="index">
            <div class="mobile-nav__item" :class="MobileShow ?'is_active':''">
              <p @click="mobileSignIn(item.link)">
                <span class="mobile-nav__label">{{item.title}}</span>
              </p>
            </div>
          </div>
        </div>
        <!-- while signed in -->
        <div
          :style="this.mobileSignedIn ?' transform: translateY(-24px);':'transform: translateY(-100%);'"
          class="mobile-nav-wrapper hidden-md-and-up"
          :class="[MobileSignedInShow ?'sub_nav__is_open':'', this.mobileSignedIn ?'mobile_nav_wrapper_show':'']"
        >
          <div class="mobile-nav" v-for="(item, index) in mobileSignedInOptions" data-index="index" :key="index">
            <div class="mobile-nav__item" :class="MobileSignedInShow ?'is_active':''">
              <p @click="mobileSignIn(item.link)">
                <span class="mobile-nav__label">{{item.title}}</span>
              </p>
            </div>
          </div>
        </div>

        <!--end header-->
        <!-- mobile group drop down -->
        <div
          :style="this.phoneNav?' transform: translateY(-24px);':'transform: translateY(-100%);'"
          class="mobile-nav-wrapper hidden-md-and-up"
          :class="[MunchiesShow?'sub_nav__is_open':'',this.phoneNav?'mobile_nav_wrapper_show':'']"
        >
          <div class="mobile-nav" v-for="(group, index) in filterGroup(allGroups)" data-index="index" :key="index">
            <div class="mobile-nav__item" :class="MunchiesShow?'is_active':''">
              <p @click="mobileNavGo(group.ProductGroup_id)">
                <span class="mobile-nav__label">{{group.Name}}</span>
                <i class="el-icon-arrow-right"></i>
              </p>
              <!-- sub group -->
              <!-- <ul class="mobile-nav__dropdown">
                <li class="mobile-nav__item mobile-son_nav__item border-bottom">
                  <div class="mobile-nav__table">
                    <div class="mobile-nav__table-cell mobile-nav__return">
                      <button class="btn--link js-toggle-submenu mobile-nav__return-btn"
                              @click="MunchiesShow = !MunchiesShow">
                        <i class="el-icon-arrow-left icon"></i>
                      </button>
                    </div>
                  </div>
                  <span
                    class="mobile-nav__sublist-link mobile-nav__sublist-header mobile-nav__sublist-header--main-nav-parent">
                  <span class="mobile-nav__label">{{group.Name}}</span>
                </span>
                </li>
                <li class="mobile-nav__item border-bottom all_mobile_link">
                  <router-link to="/account" class="mobile-nav__sublist-link">
                    <span class="mobile-nav__label">sub group</span>
                  </router-link>
                </li>
              </ul> -->
              <!-- end sub group -->
            </div>
          </div>
        </div>
        
        <appModal
          v-if="isMobile && this.showModal"
          @click="checkForClose"
          @close="this.showModal = false"
        >
        </appModal>

        <transition name="unroll">
          <div class="cart-container" v-if="this.cartClicked" >
            <div :class="(bouns && tabletDevice) ? 'flex-wrapper' : 'flex-wrapper-tab'" > 
              <table class="table">
                <thead class="thead-container">
                  <tr class="tr">
                    <th class ="th-title" colspan="2" scope="col">{{ $t('myCart') }}</th>
                  </tr>
                </thead>
                <!-- logged in -->
                <div v-if="!local">
                <thead class="thead-container">
                  <tr class="product-container" v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines">
                    <td class="cart__image-wrapper" ><img @click="goToProductDetail(item)" class="table-image" :style="'height: 100px; padding-left: 30px;'" :src="item.Thumbnail" alt=""></td>
                    <td class="cart__meta small--text-left" :style="'font-size: 12px; padding-left: 0px'">
                      <p v-if='$i18n.locale=="en"' class="product-name">{{productTitle(item)}}</p>
                      <p v-if='$i18n.locale=="ch"' class="product-name">{{item.Description}}</p>
                      <p class="unit-price">${{item.UnitPrice.toFixed(2)}}</p>
                    </td>
                    <td class="quantity-container">
                      <div class="qty_input_cart">
                        <div class="button-wrap">
                          <button class="decrement-btn" @click="updateItemCount($event, item)" >-</button>
                          <p class="product-quantity">{{item.Quantity}}</p>
                          <!-- <button :disabled="addToCartLoading" class="increment-btn" @click="throttleAddToCart(item)">+</button> -->
                          <button :disabled="false" class="increment-btn" @click="throttleAddToCart(item)">+</button>
                        </div>
                        <div class="trash-container">
                          <i v-on:click.prevent="!itemDeletedLoading && deleteItem(item)" class="fa fa-trash-o"  aria-hidden="true"></i>
                        </div>
                      </div>
                    </td>
                  </tr>
                </thead>
                <div class="price-container">
                  <div class="price-wrap">
                    <span class="price">{{ $t('subtotal') }}({{this.$store.state.cart.cartProductsList.TotalCount}} {{ $t('items') }})</span>
                    <span class="tax-footnote">{{ $t('taxAndShipping') }}</span>
                    <span class="price">${{calculateLocalSubtotal()}} </span> 
                  </div>
                  <div class="checkout-container" >
                    <button @click="postCartItemsAndCheckout($event)" class="checkout-button">{{ $t('checkOut') }}</button>
                  </div>
                </div>
              </div>
              <!-- logged out -->
              <div v-else >
                <thead class="thead-container">
                  <tr class="product-container" v-for="(item,index) in this.$store.state.cart.cartProductsList">
                    <td class="cart__image-wrapper"><img @click="goToProductDetail(item)" :src="item.Thumbnail" class="table-image" alt=""></td>
                    <td class="cart__meta small--text-left">
                      <p v-if='$i18n.locale=="en"' class="product-name">{{item.Name}}</p>
                      <p v-if='$i18n.locale=="ch"' class="product-name">{{item.Description}}</p>
                      <p class="unit-price">${{item.Price.toFixed(2)}}</p>
                    </td>
                    <td class="quantity-container">
                      <div class="qty_input_cart">
                        <div class="button-wrap">
                          <button class="decrement-btn" @click="updateItemCount($event, item)">-</button>
                          <p class="product-quantity">{{item.quantity}}</p>
                          <button class="increment-btn" @click="throttleAddToCart(item)">+</button>
                        </div>
                        <div :style="'cursor: pointer'">
                          <i v-on:click.prevent="deleteItem(item)" class="fa fa-trash-o" aria-hidden="true"></i>
                        </div>
                      </div>
                    </td>
                  </tr>
                </thead>
                <div class="price-container">
                  <div class="price-wrap">
                    <span class="price">{{ $t('subtotal') }}({{this.calculateTotalCartQuantity()}} {{ $t('items') }})</span>
                    <span class="tax-footnote">{{ $t('taxAndShipping') }}</span>
                    <span class="price">${{calculateLocalSubtotal()}} </span>
                  </div>
                  <div class="checkout-container">
                    <button @click="postCartItemsAndCheckout($event)" class="checkout-button" >{{ $t('checkOut') }}</button>
                  </div>
                </div>
              </div>
            </table>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import jquery from "jquery";
import axios from 'axios';
import _ from 'lodash';
import { mapState, mapActions, mapMutations } from 'vuex';
import { isTablet, isMobileOnly, isBrowser, deviceDetect } from 'mobile-device-detect';

import { isUserAuthenticated, setLocalCart, getLocalCart } from '../store/modules/cart';
import signUpModal from '../view/Auth/signUpModal';
import refreshSession from '../view/Modal/refreshSession';
import appModal from "../view/Modal/appModal";
import { PRODUCTS_URL } from '../api/url';

var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
let $ = jquery;
export default {
  name: "navbar",
  components: {
    signUpModal,
    refreshSession,
    appModal,
  },
  props: {
    group: {
      type: String,
      default: 'munchies'
    }
  },
  data() {
    return {
      isPhone: isMobileOnly ? true : false,
      tabletDevice: isTablet ? true : false,
      isMobileOrTablet: isMobile ? true : false,
      items:[
        { text: 'Cut' },
        { text: 'Copy' },
        { text: 'Paste' }
      ],
      // mouse hover for group image
      hoverIndex: '',
      hoverName: '',
      hoverImage: {
        1:require('../assets/img/group_noodles_hover.png'),
        2:require('../assets/img/group_baverages_hover.png'),
        3:require('../assets/img/group_munchies_hover.png'),
        4:require('../assets/img/group_eats_hover.png'),
        7:require('../assets/img/group_stationery_hover.png'),
        8:require('../assets/img/group_gift_hover.png'),
        10:require('../assets/img/group_core_hover.png'),
        11:require('../assets/img/group_sales_hover.png'),
        13:require('../assets/img/sakeHoverResize.png'),
      },
      phoneNav: false, // mobile group dropdown
      bouns: false, // 上下滑动 添加class
      scroll: 0, // 上下滑动距离
      MunchiesShow: false, // 一级导航显示
      MobileShow: false,
      MobileSignedInShow: false,
      SignInShow: false,
      search:false, // 搜索框展示
      productName:'', // 搜索绑定的值
      device: '',
      zipcode: '',
      cartX: null,
      cartY: null,
      delta: null,
      local: null,
      checkoutModal: false,
      showAccountPortal: false,
      userIconCoordinate: {
        left: 0,
        top: 0,
      },
      isMobile: isMobile,
      mobileSignUp: false,
      mobileSignedIn: false,
      mobileSignInCategories: [
        {title: 'Sign In', link: '/login' },
        {title: 'Register as a Customer', link: '/register'},
        {title: 'Register as a Business', link: '/businessRegistration'}
        ],
      mobileSignedInOptions: [
        {title: 'Sign Out', link: 'signOut'}, 
        {title: 'My Account', link: '/account'}
      ],
      showSessionModal: false,
      beenAway: false,
      tabHidden: false,
    }
  },
  methods: {
    ...mapActions('navbar',['fetchGroups']),
    ...mapActions('auth',['fetchCustomerInformation']),
    ...mapActions('cart',['addProductToCart', 'addCart', 'addProductToCartB2B']),
    ...mapActions('orders', ['fetchOrderByTimeFrame','fetchOrderDetails']),
    ...mapActions('products', ['fetchProductDetails']),
    ...mapMutations('auth', ['logout', 'updateLoginStatus', 'handleSignUpModal']),
    ...mapMutations('cart', ['resetAddToCartSuccess', 'closeCart', 'openCart', 'handleCart']), 
    ...mapMutations('navbar', ['updateSearchTerm', 'handleWindowResize', 'updateDevice', 'toggleModal', 'handleNavToAccountFromNavbar', 'mobileDevice']),
    ...mapMutations('products', ['updateActiveProduct', 'updateActiveQuantity']),
    handleMouseIn(event) {
        this.showAccountPortal = true;
    },
    handleCartMouseOver(e) {
      if (this.windowWidth > 990 && !this.tabletDevice) {
        this.toggleCart();
      }
    },
    handleWindowChange() {
      this.handleWindowResize({
        windowWidth: document.documentElement.clientWidth,
        windowHeight: document.documentElement.clientHeight,
      });
    },
    handleCartMouseOut(e) {
      if (!this.tabletDevice) {
        const classNameArray = ['cart-container', 'flex-wrapper', 'table', 'thead-container', 'tr', 'th-title', 'thead-container', 'product-container', 'cart__image-wrapper', "table-image", "cart__meta small--text-left", 'product-name', 'unit-price', 'quantity-container', 'qty_input', 'button-wrap', 'decrement-btn', 'product-quantity', 'increment-btn', 'fa fa-trash-o', 'checkout-box', 'checkout-subtotal', 'checkout-tax', 'checkout-subtotal', 'empty-space', 'checkout-button-wrap', 'btn', 'nav', 'nav_phone_left hidden-md-and-up', 'logo', 'hidden-sm-and-down', 'nav-icon', "cart-title"];
        if (e.relatedTarget) {
          if (classNameArray.includes(e.relatedTarget.className.split(' ')[0])) {
            return; 
          } else {
          this.closeCart();
          }
        }
      } else {
        this.handleCart(false);
      }
    },
    handleMouseOut(event) {
      const arrOfClassName = ["account-portal-modal", "speech-bubble", "arrow", "bubble-node"];
      if(arrOfClassName.includes(event.relatedTarget.className.split(' ')[0])) {
        return;
      }
      this.showAccountPortal = false;
    },
    navToAccount(target) {
      if (this.windowWidth > 990) {
        this.handleNavToAccountFromNavbar(target);
        if(this.$route.name !== 'account') {
          this.$router.push('/account');
        }
      } else {
        this.mobileSignedIn = !this.mobileSignedIn
      }
    },
    changeCoordinateOfModal() {
      this.userIconCoordinate = {
        // left: document.getElementsByClassName('navusername')[0].getBoundingClientRect().x - 130 + 'px',
        top: document.getElementsByClassName('navusername')[0].getBoundingClientRect().y + 29 + 'px',
      };
    },
    cartDetailsModalChange() {
      this.cartX = document.getElementsByClassName('site-header__cart-count')[0].getBoundingClientRect().x  + 'px';
      this.cartY = document.getElementsByClassName('site-header__cart-count')[0].getBoundingClientRect().y + 'px';
    },
    bounsShow() {
      if (this.bouns) {
        document.getElementsByTagName("body")[0].className = "body_top";
      } else {
        document.getElementsByTagName("body")[0].className = "";
      }
    },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scroll > 0) {
        this.bouns = true;
        this.bounsShow()
      } else {
        this.bouns = false;
        this.bounsShow()
      }
    },
    //路由跳转 1 登录 2购物车
    active(num) {
      if (num == 1) {
        this.$router.push("/login");
      } else if (num == 2) {
        this.$router.push("/cart");
      } else if (num == 3) {
        this.$router.push("/purchase");
      }
    },
    //rediract screen
    mobileNavGo(id) {
      this.phoneNav = false;
      this.navGo(id)
    },
    navGo(id) {
      const group = this.allGroups.filter( group => group.ProductGroup_id === id)[0];
      if(this.$router.currentRoute.params && this.$router.currentRoute.params.group) {
        if((this.$router.currentRoute.params.group.toLowerCase() !== group.Name.toLowerCase()) || this.$router.currentRoute.params.group.toLowerCase() === 'eats') {
          this.$router.push(`/collections/${group.Name.toLowerCase()}`)
        } else {
          this.$root.fetchSelectedGroup(group.ProductGroup_id);
        }
      } else {
        this.$router.push(`/collections/${group.Name.toLowerCase()}`)
      }
    },
    // filter core group, show for b2b only
    filterGroup(newVal, oldVal) {
      let filtered = this.allGroups;
      if (!this.business) {
        filtered = this.allGroups.filter(item => {
          return item.ProductGroup_id !== 10
        });
      }
      return filtered;
    },
    // hover on group image
    change(name, index){
      this.hoverIndex = index;
      this.hoverName = name;
    },
    phoneNavShow() {
      this.phoneNav = !this.phoneNav;
    },
    mobileSignIn(link) {
      if (link === 'signOut') {
        this.signOut();
      } else {
        this.$router.push(link)
        this.mobileSignUp = false;
      }
    },
    //搜索展示
    searchShow(){
      this.search = !this.search
    },
    toggleCart() {
      if (this.windowWidth > 990) {
          if (isUserAuthenticated()) {
            this.$store.dispatch('cart/getCart')
            .then(() => {
              this.openCart();
            })
          } else {
            this.openCart();
        }
      } else if (this.windowWidth <= 990) {
        this.$router.push('/cart');
      }
    },
    //Sign out User
    signOut() {
      this.logout();
    },
    tokenIsValid() {
      //send token to server see if it is still valid
      return true
    },
    searchProduct(product) {
      this.$router.currentRoute.path !== "/search" && this.$router.push({ path: '/search', query: { product: product}})
      this.search = false;
      this.productName = '';
      this.updateSearchTerm(product);
    },
    checkForClose(event) {
      if (event === undefined) {
        this.toggleModal(false);
        localStorage.setItem('showModal', false);
        localStorage.setItem('showModalToken', false);
      }
    },
    handleSignUpToggle(thign, event) {
      if (event.target.className === 'modal-wrapper') {
        this.handleSignUpModal(false);
        this.showSessionModal = false;
      }
    },
    routeSignUp() {
      // this is the pixel amount width amount where the navbar shifts to mobile mode.
      if (this.windowWidth >= 768) {
        this.handleSignUpModal(!this.signUpModalOpen)
      }  else {
        this.mobileSignUp = !this.mobileSignUp
      }
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
          .then(() => {
            this.$store.dispatch('cart/getCart')
          });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
  updateItemCount(e, item) {
    e.preventDefault();
      if (isUserAuthenticated()) {
      let quantity = item.Quantity - 1;
      if (quantity < 1) {
          this.deleteItem(item)
          this.local = false;
        } else {
        this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
        .then(() => { 
          this.local = false;
          this.$store.dispatch('cart/getCart');
        });
        }
      } else {
        item.quantity = item.quantity - 1;
        if (item.quantity < 1) {
          this.deleteItem(item)
        }
        this.$store.dispatch('cart/updateLocalCart', item)
        .then(() => {
          this.local = true;
          this.$store.dispatch('cart/fetchCartProducts');
        })
      }
    },
    handleCartClick(e) {
      if (this.tabletDevice) {
        this.cartClicked ? this.handleCart(false) : this.handleCart(true);
      } else {
        this.postCartItemsAndCheckout(e);
      }
    },
    postCartItemsAndCheckout(e) {
      // Make sure customer isn't already at purchase
      if (this.$router.history.current.name !== "purchase") {
        // check if they're authenticated
        if (isUserAuthenticated()) {
          // check for mobile device size
          if (this.windowWidth > 990) {
            const cartItems = {};
            cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
            cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
            cartItems.ShippingMethod = "Delivery";
            cartItems.Tip = 0;
            cartItems.TipPercentage = 0;
            cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
            this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
            .then(() => {
              this.closeCart();
              this.$router.push('/purchase');
            });
          } else {
            this.$router.push('/cart');
          }
        } else {
          this.handleSignUpModal(true); 
        } 
      }
    },
    handleAddToCartSuccess(data) {
      this.$store.dispatch('cart/addCart', data.item)
      .then(() => { 
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail(product) {
      if (product.ConvertNum <= 1) {
        alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
      }
    },
    handleAddToCartFailB(product) {
        alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
    },
    throttleAddToCart: _.debounce(function(item, event) {
      if (!this.business) {
        this.addToCart(item)
      } else {
        this.b2bAddToCart(item);
      }
    }, 150, {'leading': true, 'trailing': true}),
    addToCart: function(item) {
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})  
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])      
        }
      }
    },
    b2bAddToCart(item) {
      //  this.addCart(item)
      //  .then( () => {
      //    this.$store.dispatch('cart/getCart');
      //  })
      // if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCartB2B({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFailB, item, event: event})  
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])      
        }
      // }
    },
    getPos(el) {
    for (var lx=0, ly=0;
      el != null;
      lx += el.offsetLeft, ly += el.offsetTop, el = el.offsetParent);
      this.cartX = lx;
      this.cartY = ly;
    },
    localTotalPrice(price, quantity) {
      return (price * quantity).toFixed(2);
    },
    calculateTotalCartQuantity() {
      let totalQuantity = 0;
      for (var i = 0; i < this.cartProductsList.length; i++) {
        totalQuantity += this.cartProductsList[i].quantity;
      }
      return totalQuantity;
    },
    // make computed property
    calculateLocalSubtotal() {
      if (!isUserAuthenticated()) {
        this.local = true;
        let cost = 0;
         this.$store.state.cart.cartProductsList.map(item => {
          let itemPrice = item.Price * item.quantity;
          cost += itemPrice; 
        })
        return cost.toFixed(2);
      } else {
        this.local = false;
        return this.cartProductsList.TotalPrice.toFixed(2);
      }
    },
    // When a B2B user logs in, this function will remove all single items and replace them with inner/master case options. It currently does not select for stock. 
    removeSingleItemsAndReplaceWithCases() {
      if (this.cartProducts.length) {
        this.cartProducts.map(localCartItem => {
          let num = localCartItem.ProductNum;
          const config = {
            method: 'get',
            url: `${PRODUCTS_URL}${num}`,
          };
          if (num.charAt(num.length - 1) !== '0' || num.charAt(num.length - 1) !== '2') {           
            this.$store.dispatch('cart/deleteCartItem', localCartItem.Product_id)
              axios(config)
              .then( (res) => {
                if (res.data.length > 1) {
                  res.data.slice(1).map(nonSingleProduct => {
                    this.$store.dispatch('cart/addCart', nonSingleProduct)
                  })
                }
            });
          }
        });
      }
    },
    goToProductDetail(product) {
      if (this.business) {
        let num = product.ProductNum;
        if (num.charAt(num.length - 1) === '0' || num.charAt(num.length - 1) == '2') {
          let singleNum = product.ProductNum.slice(0, -1) + "1";
          this.updateActiveProduct(singleNum);
          this.$router.push({ 
            name: 'productDetails', 
            query: { productNum: singleNum 
          }})
        }
      } else {
        this.updateActiveProduct(product.ProductNum);
        this.$router.push({ 
          name: 'productDetails', 
          query: { productNum: product.ProductNum 
        }})
      }
    },
    langChanged(lang) {
      localStorage.Lang=lang;
      if(localStorage.Lang!=null) this.$i18n.locale=localStorage.Lang;
    },
    closeSessionExpirationModal() {
      this.signOut();
    },
    productTitle(item) {
      if (!this.business) {
        return item.Name
      }
      if (this.business) {
        if (item.ProductNum.charAt(item.ProductNum.length -1) === '0') {
          return item.Name + '(Master Case)';
        }
        if (item.ProductNum.charAt(item.ProductNum.length -1) === '2') {
          return item.Name + '(Inner Case)';
        } else {
          return item.Name
        }
      }
    },
  },
  beforeMount() {
    if (isUserAuthenticated()) {
      this.local = false;
      this.$store.dispatch('cart/getCart');
    } else {
      this.local = true;
      this.$store.dispatch('cart/fetchCartProducts');
    }
    if (window.screen.width < 900) {
      //WAP and ONLINE are what Yuansfer uses to distinguish between mobile
      //and desktop devices. 
      this.updateDevice('WAP');
    } else {
      this.updateDevice('ONLINE');
    }
    if (window.screen.width <= 500) {
      this.mobileDevice(true);
    } else {
      this.mobileDevice(false);
    }

    if (localStorage.getItem('showModalToken') !== true && localStorage.getItem('showModalToken') !== false) {
      localStorage.setItem('showModalToken', true);
    }
    if (localStorage.getItem('showModal') !== true && localStorage.getItem('showModal') !== false) {
      localStorage.setItem('showModal', true);
    }
  },
  beforeCreate() {
      if (isUserAuthenticated()) {
      this.$store.dispatch('auth/fetchCustomerInformation')
      this.$store.dispatch('orders/fetchOrderByTimeFrame', 3);
    }
  },
  mounted() {
    let cart = document.getElementsByClassName('site-header__cart-count')[0];
    if(localStorage.getItem('token') && this.tokenIsValid(localStorage.getItem('token'))) {
      this.updateLoginStatus(true);
    };
    window.addEventListener('scroll', this.handleScroll, true);
    this.fetchGroups();
    if (this.$router.history.current.name !== 'purchase' && localStorage.getItem('showModalToken') === true) { 
      this.toggleModal(true);
    }
    this.getPos(cart);
    this.$nextTick(function() {
      this.changeCoordinateOfModal();
      this.handleWindowChange();
    })
    if(localStorage.Lang!=null) this.$i18n.locale=localStorage.Lang;
  },
  created() {
    window.addEventListener('resize', this.changeCoordinateOfModal);
    window.addEventListener('resize', this.handleWindowChange);
  },
  destroyed() {
    window.removeEventListener("resize", this.changeCoordinateOfModal);
    window.removeEventListener('resize', this.handleWindowChange);
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    cart: state => state.cart.itemCount,
    allGroups: state => state.navbar.allGroups,
    cartProducts: state => state.cart.cartProductsList,
    showModal: state => state.navbar.showModal,
    showModalToken: state => state.navbar.showModalToken,
    addToCartLoading: state => state.cart.addToCartLoading,
    addToCartSuccessful: state => state.cart.addToCartSuccessful,
    cartClicked: state => state.cart.cartClicked,
    cartProductsList: state => state.cart.cartProductsList,
    token: state => state.auth.token,
    mobile: state => state.navbar.mobile,
    itemDeletedLoading: state => state.cart.itemDeletedLoading,
    itemDeleted: state => state.cart.itemDeleted,
    windowWidth: state => state.navbar.windowWidth,
    business: state => state.auth.userDetails.IsBusiness,
    signUpModalOpen: state => state.auth.signUpModalOpen,
    activeProduct: state => state.products.activeProduct,
    activeQuantity: state => state.products.activeQuantity,
    unauthorized: state => state.cart.unauthorized
  }),
  watch: {
    business: function(newVal, oldVal) {
      immediate: true;
        if (newVal === false && newVal !== oldVal) {
          if (this.cartProducts.length) {
            this.cartProducts.map(localCartItem => {
              this.$store.dispatch('cart/addCart', localCartItem)
            });
          }
        } 
        else if (newVal && newVal !== oldVal) {
            this.removeSingleItemsAndReplaceWithCases()
        }
    },
    activeProduct: function(newVal, oldVal) {
      immediate: true;
      if (newVal !== oldVal ) {
        let quantFound = false;
        if (isUserAuthenticated()) {
          this.cartProductsList.Sales_Order_Lines.map(item => {
            if (item.ProductNum === newVal) {
              quantFound = true;
              this.updateActiveQuantity(item.Quantity);
            }
          })
        } else {
          this.cartProductsList.map(item => {
            if (item.ProductNum === newVal) {
              quantFound = true;
              this.updateActiveQuantity(item.quantity);
            }
          })
        }
        if (!quantFound) {
          this.updateActiveQuantity(0);
        }
      }
    },
    loggedIn: function(newVal, oldVal) {
      immediate: true;
      if (oldVal === true && newVal === false) {
        this.local = true;
        this.$store.dispatch('cart/deleteLocalCart')
        this.handleSignUpModal(false); 
      } else if (newVal === true && oldVal === false) {
        this.handleSignUpModal(false);
        this.local = false;
      }
      if (newVal !== oldVal && this.signUpModalOpen) {
        this.handleSignUpModal(false);
      }
    },
    showModal: function(newVal, oldVal) {
      if (this.mobile) {
        if (newVal === true) {
          document.documentElement.style.overflow = 'hidden';
          return;
        } else {
          document.documentElement.style.overflow = 'auto';
        }
      }
    },
    token: function(newVal, oldVal) {
      immediate: true;
      if (newVal !== null || newVal !== undefined) {
        this.local = false;
        this.$store.dispatch('cart/getCart');
      } else {
        this.local = true;
        this.$store.dispatch('cart/fetchCartProducts');
      }
    },
    itemCount: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart')
        } else {
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
    addToCartSuccessful: function(newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        setTimeout(() => {
          this.resetAddToCartSuccess();
        }, 4000)
      }
    },
    unauthorized: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        let that = this;
        setTimeout(function() {
          that.showSessionModal = true;
        }, 1000)
      }
    },
  }
}
</script>

<style lang="less">
@import "../assets/css/navbar.less";
@import "../assets/css/public.less";
@import "../assets/css/cartContainer.less"; 

.unroll-enter-active {
  transition: opacity .3s;
}
.unroll-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.unroll-enter, .unroll-leave-to {
  opacity: 0;
}
.account-portal-modal {
  background-color: #f8f8f8;
  border-radius: 5px;
  width: 200px;
  height: 270px;
  text-align: center;
  padding: 20px;
  padding-top: 0;
  position: absolute;
  box-shadow: 1px 10px 15px rgba(0, 0, 0, 0.2);
  z-index: 7;
}

.modal-data-container {
  display: block;
  text-align: left;

  .usernameDisplayInBuble {
    color: grey;
    cursor: pointer;
    padding: 12px 0;
    font-size: 70%
  }

  .portal-links-container {
    padding: 20px 0;
    .each-link {
      line-height: 30px;
      cursor: pointer;
    }
  }

  .logout {
    cursor: pointer;
  }
}

.arrow {
  position: inherit;
  border-style: dashed;
  border-color: transparent;
  border-width: 0.20em;
  display: -moz-inline-box;
  display: inline-block;
  /* Use font-size to control the size of the arrow. */
  font-size: 50px;
  height: 0;
  line-height: 0;
  position: relative;
  vertical-align: middle;
  width: 0;
  background-color:transparent; /* change background color acc to bg color */ 
  border-bottom-width: 0.2em;
  border-bottom-style: solid;
  border-bottom-color: #f8f8f8;
  bottom:0.25em;
  top: -23px;
  left: 50px;
  z-index: inherit;
}

// .ui-select{width: 100%;}
// select::-ms-expand {	display: none; }
// select{
//     -webkit-appearance: none;
//     appearance: none;
// }
// @-moz-document url-prefix(){
// 	.ui-select{border: 1px solid #CCC; border-radius: 4px; box-sizing: border-box; position: relative; overflow: hidden;}
//   .ui-select select { width: 110%; background-position: right 30px center !important; border: none !important;}
// }
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue